// Path: Bet/frontend/src/components/Cards/suggestions.js

import React from "react";
import Card from "react-bootstrap/Card";
import { styles } from "../../styles/styles.js"; // Adjust the path if needed
import ReactMarkdown from "react-markdown";

const cardStyle = {
  marginBottom: "10px",
  backgroundColor: "black",
  color: "white",
  borderColor: "white",
  borderWidth: 1,
  borderStyle: "solid",
  padding: 20,
};

const headerStyle = {
  fontSize: 'clamp(20px, calc(12px + (11) * ((100vw - 400px) / (1200 - 320))), 30px)',
  fontWeight: 'bold',
  marginBottom: '10px',
  color: 'white'
};

const safeJsonParse = (jsonString) => {
  try {
    // If it's already an object, return it
    if (typeof jsonString === 'object' && jsonString !== null) {
      return jsonString;
    }
    
    // If it's a string, clean it and try to parse it
    if (typeof jsonString === 'string') {
      // Remove any potential bad control characters
      const cleanedString = jsonString.replace(/[\u0000-\u001F]/g, '')
                                    .replace(/\\n/g, '\\n')
                                    .replace(/\\"/g, '\\"');
      return JSON.parse(cleanedString);
    }
    
    return null;
  } catch (error) {
    console.error('JSON parsing error:', error);
    return null;
  }
};

const SuperSummary = ({ fixture, userTier, isFixtureUnlocked, desktop = false }) => {
  if (userTier === "Anon") {
    return null;
  }

  if (!fixture.box_score) {
    return null;
  }


  const renderCard = (title, key) => {
    const data = safeJsonParse(fixture.box_score[key]);
    return (
      <Card style={{...cardStyle}}>
        <Card.Body>
          <h3 style={headerStyle}>{title}</h3>
          <Card.Text style={styles.analysis}>
            {data ? <ReactMarkdown>{Array.isArray(data.text) ? data.text.join('\n\n') : data.text}</ReactMarkdown> : 'Data unavailable'}
          </Card.Text>
          <br />
          <div style={{fontSize: 'clamp(20px, calc(7px + (4) * ((100vw - 300px) / (1200 - 320))), 60px)'}}>
            Confidence Score: {data?.confidence_score ?? 'N/A'}
          </div>
        </Card.Body>
      </Card>
    );
  };

  const pairs = [
    { label: 'Moneyline', left: { title: 'Moneyline — Favorite', key: 'moneyline_favored' }, right: { title: 'Moneyline — Underdog', key: 'moneyline_underdog' } },
    { label: 'Spread', left: { title: 'Spread — Favorite', key: 'spread_favored' }, right: { title: 'Spread — Underdog', key: 'spread_underdog' } },
    { label: 'Over/Under', left: { title: 'Over', key: 'over' }, right: { title: 'Under', key: 'under' } },
  ];

  // The seventh card, present only where the competition has a draw market and
  // the summarizer therefore produced the pick. Unpaired on purpose: a draw is
  // not the opposite of anything, so it has no facing advocate to sit beside.
  const hasDraw = Boolean(fixture.box_score.moneyline_draw);

  if (desktop) {
    return (
      <div style={{ marginTop: "20px" }}>
        <h5 style={{ marginBottom: "15px" }}>Super Summary</h5>
        {pairs.map(({ label, left, right }) => (
          <div key={label} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
            {renderCard(left.title, left.key)}
            {renderCard(right.title, right.key)}
          </div>
        ))}
        {hasDraw && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', marginBottom: '20px' }}>
            {renderCard('Draw', 'moneyline_draw')}
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <h5 style={{ marginBottom: "15px" }}>Super Summary</h5>
      {renderCard('Want to bet the moneyline on the favorite?', 'moneyline_favored')}
      {renderCard('Want to bet the moneyline on the underdog?', 'moneyline_underdog')}
      {renderCard('Want to bet the spread on the favorite?', 'spread_favored')}
      {renderCard('Want to bet the spread on the underdog?', 'spread_underdog')}
      {renderCard('Want to bet the over?', 'over')}
      {renderCard('Want to bet the under?', 'under')}
      {hasDraw && renderCard('Want to bet the draw?', 'moneyline_draw')}
    </div>
  );
};

export default SuperSummary;